import React, {useState, useEffect} from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

const EcosystemStats = ({staked, locked}) => {
  const [activeButton, setActiveButton] = useState('24H');
  const buttons = ['24H', '7D', '30D', '1YR', 'ATL'];
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true,   
    });
  }, []);

  return (
  <>
  <section className="excoSystemSec stakeSec  StatsSec leftrightSecSpace">
    <div className="">
      <h2 className="good_times goldFont">Eco System Stats</h2>
      <div className="gredientBG subcontent subPad SRTOP p-0">
        <div className="dateEco d-flex justify-content-between align-items-center">
          <div className="iconSR"><img className="img-fluid" src="./images/Coins.svg" /></div>
        </div>
        <div className="statsALL">
          <div className="row">
            <div className="col-sm-12 col-lg-6 borderRight mobBorderBottomAdd991 borderBottom">
              <div className="EcoSN"   data-aos-delay="800" data-aos-duration="400">
                <div className="d-flex justify-content-between gap-1 align-items-center">
                  <div className="perVal fInter d-flex align-items-center">
                    <span className="">PTGC Staked Only </span>
                  </div>
                </div>
                <div className="statBottom" style={{paddingTop:'16px'}}>
                  <div className="dollorVal dollorValRight mt-0 mb-0"><span className="val f18">{parseFloat((staked - locked)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-lg-6  borderRight mobBorderBottomAdd991 borderBottom">
              <div className="EcoSN"  data-aos-delay="800" data-aos-duration="600">
                <div className="d-flex justify-content-between gap-1 align-items-center">
                  <div className="perVal fInter d-flex align-items-center">
                    <span className="">PTGC Staked & Locked</span>
                  </div>
                </div>
                <div className="statBottom" style={{paddingTop:'16px'}}>
                  <div className="dollorVal dollorValRight mt-0 mb-0"><span className="val f18">{parseFloat(locked).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </>
  );
};

export default EcosystemStats;